import VuetifyConfirm from 'vuetify-confirm';

export default VuetifyConfirm;
